module.exports = __webpack_public_path__ + "img/icon_swipe.0c02caf9.svg";